export const colors = {
  primary: "#5514b4",
  secondary: "#e60050",
  textColor: "#646464",
  bgColor: "#cdcdcd",
  buttonColor: "#32008a",
};
